module.exports = __webpack_public_path__ + "img/round2-variation1.dd501798.gif";